<section>
    <div class="rum-container grid mt-5">
        <div class="col-12 md:col-2 lg:col-2 xl:col-2"></div>
        <div class="col-12 md:col-8 lg:col-8 xl:col-8">
            <ng-content></ng-content>
        </div>
        <div class="col-12 md:col-2 lg:col-2 xl:col-2"></div>
    </div>
</section>